// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1U-f9","productName":"Table_productName__25Ldd"};